import type { User } from '@owl-frontend/api-client/interface';
import { AsyncActionState, setupSlice } from '@owl-frontend/redux';

export interface UsersState {
  users: User[];
  actions: {
    createUser: AsyncActionState<User>;
    deleteUser: AsyncActionState;
    listUsers: AsyncActionState;
    updateUserRole: AsyncActionState;
    updateUserSettings: AsyncActionState;
    updateEmailSubscriptions: AsyncActionState;
  };
}

const initialState: UsersState = {
  users: [],
  actions: {
    createUser: { status: 'uninitialized' },
    deleteUser: { status: 'uninitialized' },
    listUsers: { status: 'uninitialized' },
    updateUserRole: { status: 'uninitialized' },
    updateUserSettings: { status: 'uninitialized' },
    updateEmailSubscriptions: { status: 'uninitialized' },
  },
};

const usersSlice = setupSlice('users', initialState);
export default usersSlice;
